<template>
    <div v-show="entry.id">{{ feeHeadDetails(entry.fee_head_id)?.name }}</div>
    <small v-show="entry.due_from_receipt_id && showDueFromReceipt">
        Due from receipt
        <a target="_blank"
           :href="route('fees.collections.receipt', {record: entry.due_from_receipt_id ?? 0})">
            {{ entry.due_from_receipt_display_id || entry.due_from_receipt_id || '' }}
        </a>
    </small>
    <div v-show="!entry.id">
        <select title="Select Fee Head"
                class="form-control selectpicker"
                data-live-search="true"
                v-model="entry.fee_head_id"
                v-bind:class="{ 'is-invalid' : error }"
                @change="onFeeHeadChange(index)">
            <option v-for="feeHead in feeHeads"
                    :value="feeHead.id">{{ feeHead.name }}
            </option>
        </select>
        <small class="invalid-feedback d-block"
               v-show="error !== ''">
            {{ error || '' }}
        </small>
    </div>
</template>

<script>

export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        feeHeads: {
            type: Array,
            required: true,
        },
        onFeeHeadChange: {
            type: Function,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
        showDueFromReceipt: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    methods: {
        feeHeadDetails(id) {
            return this.feeHeads.find(head => id === head.id)
        },
    }
}
</script>

<style scoped>

</style>
